import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { LoginComponent } from './components/pages/login/login.component';
import { UnauthorizedComponent } from './components/pages/unauthorized/unauthorized.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';

const routes: Routes = [
  { path: 'lectures', loadChildren: () => import(`./modules/lectures/lectures.module`).then(m => m.LecturesModule), canActivate: [AuthGuard, RoleGuard], data: {requiredRole: 'ROLE_BACKOFFICE_LESSON'} },
  { path: 'tutoring', loadChildren: () => import(`./modules/tutoring/tutoring.module`).then(m => m.TutoringModule), canActivate: [AuthGuard, RoleGuard], data: {requiredRole: 'ROLE_BACKOFFICE_TUTOR'} },
  { path: 'notifications', loadChildren: () => import(`./modules/notifications/notifications.module`).then(m => m.NotificationsModule) }, //canActivate: [AuthGuard, RoleGuard], data: {requiredRole: 'ROLE_SUPERVISOR'}
  { path: 'presences', loadChildren: () => import(`./modules/presences/presences.module`).then(m => m.PresencesModule), canActivate: [AuthGuard, RoleGuard], data: {requiredRole: 'ROLE_SUPERVISOR'} },
  { path: 'login', component: LoginComponent },
  { path: '', component: HomeComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
